const BASE_PATH = "app/admin/photos/";

export const SET_PHOTOS = `${BASE_PATH}set-photos`;
